// Process polyfill for browser environment - MUST be loaded first
// This is a fallback - the main polyfill is in index.html
(function () {
  'use strict';

  // Immediately define process if it doesn't exist to prevent ReferenceError
  // Use globalThis as the primary target for modern browsers
  const globalObj = (function () {
    if (typeof globalThis !== 'undefined') return globalThis;
    if (typeof window !== 'undefined') return window;
    if (typeof global !== 'undefined') return global;
    if (typeof self !== 'undefined') return self;
    return this;
  })();

  // Check if process already exists (from index.html polyfill)
  if (typeof globalObj.process !== 'undefined' && globalObj.process.env) {
    return; // Already defined, skip
  }

  // Immediately set a basic process object to prevent ReferenceError
  // This must happen BEFORE any code tries to access process
  if (typeof globalObj.process === 'undefined') {
    globalObj.process = {
      env: {
        NODE_ENV: 'development',
        REACT_APP_API_BASE_URL: 'http://localhost:7005',
        REACT_APP_FRONTEND_URL: 'http://localhost:7000',
      },
      browser: true,
      version: '16.0.0',
      platform: 'browser',
      argv: [],
      cwd: function () {
        return '/';
      },
      nextTick: function (fn) {
        if (typeof fn === 'function') setTimeout(fn, 0);
      },
    };
  }

  // Also set on window if different from globalObj
  if (
    typeof window !== 'undefined' &&
    window !== globalObj &&
    typeof window.process === 'undefined'
  ) {
    window.process = globalObj.process;
  }

  // Also set on globalThis explicitly
  if (
    typeof globalThis !== 'undefined' &&
    typeof globalThis.process === 'undefined'
  ) {
    globalThis.process = globalObj.process;
  }

  // Check if process already exists and is properly configured
  if (typeof process !== 'undefined' && process.env && process.env.NODE_ENV) {
    return;
  }

  // Create a comprehensive process polyfill
  const processPolyfill = {
    env: {
      NODE_ENV: 'development',
      REACT_APP_API_BASE_URL: 'https://cmsbe.muraasala.com',
      REACT_APP_CMS_API_URL: 'https://cmsbe.muraasala.com',
    },
    browser: true,
    version: '16.0.0',
    platform: 'browser',
    argv: [],
    cwd: function () {
      return '/';
    },
    nextTick: function (fn) {
      if (typeof fn === 'function') {
        setTimeout(fn, 0);
      }
    },
    umask: function () {
      return 0;
    },
    chdir: function () {
      return processPolyfill.cwd();
    },
    exit: function (code) {
      console.warn('process.exit called with code:', code);
    },
    kill: function () {
      console.warn('process.kill called');
    },
    on: function () {
      console.warn('process.on called');
    },
    addListener: function () {
      console.warn('process.addListener called');
    },
    once: function () {
      console.warn('process.once called');
    },
    removeListener: function () {
      console.warn('process.removeListener called');
    },
    removeAllListeners: function () {
      console.warn('process.removeAllListeners called');
    },
    emit: function () {
      console.warn('process.emit called');
    },
    prependListener: function () {
      console.warn('process.prependListener called');
    },
    prependOnceListener: function () {
      console.warn('process.prependOnceListener called');
    },
    listeners: function () {
      return [];
    },
    binding: function () {
      return {};
    },
    hrtime: function () {
      return [Date.now(), 0];
    },
    release: {},
    config: {},
    uptime: function () {
      return Date.now() / 1000;
    },
  };

  // Set process on all possible global objects
  const globalObjects = [
    typeof globalThis !== 'undefined' ? globalThis : null,
    typeof global !== 'undefined' ? global : null,
    typeof window !== 'undefined' ? window : null,
    typeof self !== 'undefined' ? self : null,
  ].filter(Boolean);

  globalObjects.forEach((obj) => {
    try {
      obj.process = processPolyfill;
      // Also set process.env if it doesn't exist
      if (!obj.process.env) {
        obj.process.env = processPolyfill.env;
      }
    } catch (e) {
      // Ignore if this fails
    }
  });

  // Ensure process is available globally
  try {
    if (typeof globalThis !== 'undefined') {
      globalThis.process = processPolyfill;
    }
    if (typeof window !== 'undefined') {
      window.process = processPolyfill;
    }
  } catch (e) {
    // Ignore if this fails
  }

  // Export the process polyfill
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = processPolyfill;
  }
})();
